import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const fetchNextSales = createCallbackActionCreator(
  'SALES.FETCH_NEXT_SALES'
);
